import axios from 'axios'
import { Device } from "twilio-client"

export default {
    namespaced: true,
    state: {
        call: false,
        currentCallSid: null,
        confParams: null
    },
    mutations: {
        SET_CALL(state, call) {
            state.call = call;
        },
        SET_CURRENT_CALL_SID(state, callSid) {
            state.currentCallSid = callSid;
        },
        SOCKET_SET_CONF_PARAMS(state, confParams) {
            state.confParams = confParams;
        }
    },
    getters: {
        online: state => state.online,
        call: state => state.call,
        currentCallSid: state => state.currentCallSid,
        confParams: state => state.confParams
    },
    actions: {
        setOnline({ commit }, user_id) {
            commit("SET_ONLINE", true);
            commit("SET_LOADING_ONLINE", true);
            axios.post("/call/token/" + user_id)
                .then((res) => {
                    Device.setup(res.data.token, { debug: true, dscp: true });
                    commit("SET_LOADING_ONLINE", false);
                })
                .catch((err) => {
                    commit("SET_ONLINE", false);
                    commit("SET_LOADING_ONLINE", false);
                    console.log(err);
                });
        },

        setOffline({ commit }) {
            commit("SET_ONLINE", false);
            Device.destroy();
        }
    },
}
